module.exports = __webpack_public_path__ + "static/media/mercuryzone--logo.cbe1402b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/mercuryzone/mercuryzone--logo.svg
// module id = 159
// module chunks = 0